/* eslint-disable @angular-eslint/directive-selector */
import { Component, HostBinding, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'search-title',
  templateUrl: './search-title.component.html',
  styleUrls: ['./search-title.component.scss'],
  host: { class: 'search-title' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SearchTitleComponent implements OnInit {
  @Input() accentColor: 'blue' | 'grey' | 'green' = 'green';
  @Input() darkMode = false;

  @HostBinding('class') get classes() {
    const accent = this.accentColor;
    return `${accent} ${this.darkMode ? 'dark-mode' : ''}`;
  }
  ngOnInit() {}
}
